import { cloudChiprApi } from "../../../services/cloudchipr.api";

export const integrationsSelector =
  cloudChiprApi.endpoints.getUsersMeIntegrations.select({});
